import http from './httpService';

const apiEndpoint = 'https://tau-chain-parser-api.herokuapp.com/api/logs';

export function getAllLogs(param) {
  if (param) { return http.get(`${apiEndpoint}/${param}`); }

  return http.get(apiEndpoint);
}
